import React from 'react'
import { useTranslation } from 'react-i18next'
import { MegaTagTitle } from '@/components/Elements'
import { ProfileContainer } from '@/features/profile/components/Profile'

export const Profile = () => {
  const { t } = useTranslation()

  return (
    <>
      <MegaTagTitle title={'personal_data_settings'} />

      <ProfileContainer />
    </>
  )
}
